import React from "react";

const CONTENT = {
  terms: {
    title: "Terms of Service",
    body: [
      "By using EarlyPrint you agree to these terms. EarlyPrint operates as a marketplace connecting customers with independently owned print vendors.",
      "You may not upload files that infringe intellectual property, are unlawful, or violate our vendor community guidelines.",
      "Prices displayed are quotes from independent vendors. EarlyPrint charges a small platform fee on completed orders.",
      "All payments are held in escrow and released to the vendor only after you confirm delivery.",
      "For any dispute, our support team mediates fairly based on evidence provided by both parties.",
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      "We collect the minimum information needed to run your account and place orders — name, email, phone, delivery address and design files you choose to upload.",
      "Your uploaded design files are shared only with the vendors you request quotes from or the vendor you select.",
      "We use Google OAuth for one-tap sign in. We never store your Google password.",
      "You can request account deletion at any time by writing to hello@earlyprint.in.",
      "We use cookies to remember your session and improve the site experience.",
    ],
  },
  refund: {
    title: "Refund & Escrow Policy",
    body: [
      "Every payment on EarlyPrint is held in escrow. Funds are released to the vendor only after you confirm delivery of your order.",
      "If your order does not match the specifications you approved, raise a dispute within 48 hours of delivery.",
      "Our team reviews the dispute and, based on evidence, issues a full or partial refund to your EarlyPrint wallet.",
      "Refunds credited to your wallet can be used on future orders or withdrawn to your linked bank/UPI, subject to identity verification.",
      "Orders cancelled before printing starts are fully refundable. Cancellations after printing has begun may be subject to a partial charge covering materials used.",
    ],
  },
};

export default function LegalPage({ kind }) {
  const c = CONTENT[kind];
  return (
    <section className="border-b border-neutral-200">
      <div className="mx-auto max-w-3xl px-4 py-16 md:px-6 md:py-24">
        <span className="text-xs font-semibold uppercase tracking-widest text-neutral-500">Legal</span>
        <h1 className="mt-2 font-display text-4xl font-black tracking-tight md:text-5xl" data-testid={`legal-${kind}-title`}>{c.title}</h1>
        <div className="prose mt-8 max-w-none space-y-4 text-sm text-neutral-700">
          {c.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
        <p className="mt-10 text-xs text-neutral-500">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</p>
      </div>
    </section>
  );
}
